import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyField } from '../../Field/CurrencyField';
import {
  useAccountProductCryptoQuery,
  useAccountProductFiatQuery,
  useAccountsQuery,
} from '../../../api/accounts';
import { CustomerField } from '../../Field/CustomerField';
import { uniq } from 'lodash-es';

export function InternalBeneficiaryFields() {
  const { t } = useTranslation();
  const fiatProductQuery = useAccountProductFiatQuery();
  const cryptoProductQuery = useAccountProductCryptoQuery();

  const accountsQuery = useAccountsQuery();
  const currencies = useMemo(
    () => uniq(accountsQuery.data?.map(({ balance }) => balance.currency) ?? []),
    [accountsQuery.data],
  );

  return (
    <>
      <CurrencyField
        name="beneficiary.value.currency"
        label={t('Currency')}
        options={currencies}
        loading={fiatProductQuery.isPending || cryptoProductQuery.isPending}
        autoFocus
        required
        disableClearable
        openOnFocus={false}
      />
      <CustomerField
        name="beneficiary.value.receiverId"
        label={t('{{companyName}} user')}
        required
        disableClearable
      />
    </>
  );
}
